module.exports = __webpack_public_path__ + "images/social-butterfly-ef6220c1aeac08590c8e60ea12e50701.png";